@if(auth.isInitialized() && !auth.loggedIn() && !auth.isLoggingOut()) {
    <app-login></app-login>
}
@else if(auth.isLoading() || auth.isLoggingOut()) {
    <nz-spin nzSimple />
}
@else{
    <app-login [forceLogin]="true"></app-login>
}
